<!--The Heading sections (Heading + Search )-->
<div class="row header-section mt-5">

  <div class="col-lg-6 col-md-9 col-sm-9 col-xs-12">
    <h4>
      Waves
    </h4>
  </div>

  @if (defaults.isMersyAdminUser  || defaults.isMersyAdminSafetySystemExcellence) {
    <div class="col-lg-6 col-md-3 col-sm-3 col-xs-12 flex-right">
      <div class="OrangeButton" style="margin-right: 50px;">
        <button mat-raised-button (click)="openCreateWavePopup()" title="Create new Wave" class="btn btn-sm button-color-fix">
          Add Wave <mat-icon class="add-button icon-color-fix">add_box</mat-icon>
        </button>
      </div>
    </div>
  }

</div>

<div class="">
  <table mat-table #itemsList
    [dataSource]="dataSource"
    multiTemplateDataRows
    class="mat-elevation-z8 mat-table-custom" id="osh-waves">

    <ng-container matColumnDef="Select">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element"
        (click)="onSelectWave(element)"
        (keydown)="$event.key === 'Enter' || $event.key === ' ' ? onSelectWave(element) : null"
        tabindex="0">
        @if (selectedWave?.id === element.id) {
          <span class="material-icons" matTooltip="Collapse">
            expand_less
          </span>
        } @else {
          <span class="material-icons" matTooltip="More Details">
            expand_more
          </span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="Name">
      <th mat-header-cell *matHeaderCellDef> Name </th>
      <td mat-cell *matCellDef="let element">
        <p [innerHTML]="element.name"></p>
      </td>
    </ng-container>

    <ng-container matColumnDef="Description">
      <th mat-header-cell *matHeaderCellDef> Description </th>
      <td mat-cell *matCellDef="let element">
        <p [innerHTML]="element.description"></p>
      </td>
    </ng-container>

    <ng-container matColumnDef="StartDate">
      <th mat-header-cell *matHeaderCellDef> Start Date </th>
      <td mat-cell *matCellDef="let element">
        <p [innerHTML]="element.startDate | date:'yyyy-MM-dd HH:mm'"></p>
      </td>
    </ng-container>
    <ng-container matColumnDef="EndDate">
      <th mat-header-cell *matHeaderCellDef> End Date </th>
      <td mat-cell *matCellDef="let element">
        <p [innerHTML]="element.endDate | date:'yyyy-MM-dd HH:mm'"></p>
      </td>
    </ng-container>

    @if (defaults.isMersyAdminUser  || defaults.isMersyAdminSafetySystemExcellence) {
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions </th>
        <td mat-cell *matCellDef="let element; let i = dataIndex">
          <button mat-icon-button matTooltip="Edit Wave" (click)="onEditWave(element)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button matTooltip="Remove Wave" (click)="onRemoveWave(element)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>
    }

    <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;" class="item"
      [ngClass]="selectedWave.id === element.id ? 'orange-background':''">
    </tr>
  </table>
</div>





